import '../../App.less';
import {Popconfirm, Layout, Row, Col,ConfigProvider,Table,Modal,Transfer,Menu,Input, Space, AutoComplete,notification, Select,Form } from 'antd';
import React, { Component } from "react";
import 'react-phone-input-2/lib/style.css'
import es_ES from 'antd/lib/locale/es_ES';
import { Button } from 'antd';
import Highlighter from 'react-highlight-words';
import {DeleteOutlined, SearchOutlined,CheckOutlined,  UserOutlined,EditOutlined,MailOutlined, PhoneOutlined, GlobalOutlined, EnvironmentOutlined, IdcardOutlined } from '@ant-design/icons';
import axios from "axios";
import countries from '../../static/json/countries.json'
import PhoneInput from 'react-phone-input-2'
import es from 'react-phone-input-2/lang/es.json'
import {getAuthors,getAuthorsStr, getCountryName,IP,getCountryCode  } from '../components/utils';
import Foot from "../components/Footer"
import AdminMenu from "../components/AdminMenu"


class AdminJury extends Component {
  constructor(props){
    super(props)
    const { Option } = Select;
    this.state={
      phone: '',
      plays:[],
      edit:false,
      countryName:'',
      countryChanged:'',
      filteredInfo:[],
      genre:{},
      create:false,
      name:'',
      showAddPlays:false,
      unassignedPlays:[],
      assignedPlays:[],
      saveAddPlays:false,
      newJuryCategory:2,
      isBusy:true
    }
  }
  async componentDidUpdate(prev){
    if(prev.juryType != this.props.juryType){
      this.componentWillMount()
    }
  }
  
  async componentWillMount() {
    const response_jury= await fetch(IP + 'api/casa/jurado/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
    },
    });
    var json_jury = await response_jury.json();
    if(json_jury['detail']){
      localStorage.clear()
      window.location.reload(); 
    }
    json_jury =  json_jury.filter(j=>j.premio==4)
    const response_plays= await fetch(IP + 'api/casa/obra/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
    },
    });
    const response_genr= await fetch(IP + 'api/casa/genero/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
    },
    });
    const json_plays = await response_plays.json();
    const json_genre = await response_genr.json();
    this.genre = {}
    var data_jury = []
    this.plays_dict = {}
    
    const Moment = require('moment');

    json_genre.map(g=>{this.genre[g.id] = g})//Build genre dict by id
    json_plays.map(play=>{ //Build plays data
      var date= new Moment(play.fecha_registro).format('DD-MM-YYYY')
      var year = date.split('-')[2]
      play.author = getAuthors(play.conc)
      play.authorStr = getAuthorsStr(play.conc).join(", ")
      play.countryName= getCountryName(play.conc[0].pais)
      play.date = date 
      play.code=year+'_'+play.genero+'_'+play.id
      play.genero_nombre=this.genre[play.genero].nombre
      if(play.preseleccionada)
        this.plays_dict[play.id] = play
    })
    this.jury_plays = []
    this.names = new Set();
    this.categories = new Set();
    this.users = new Set();
    console.log("GENRE",this.genre)
    console.log("JURADO",json_jury)
    for(const i in json_jury){//build jury data
      const jury = json_jury[i];
      console.log("jur",jury,this.genre)
      if(this.props.juryType == this.genre[jury.genero].nombre || (this.props.juryType == "all" && this.genre[jury.genero].nombre != 'Admin' )){//props.juryType indicates type of jury selected from Menu. Admins are also Jury, but its genre is Admin to identify from regular Jury
        var plays_objects =  jury.obras.map(p=>this.plays_dict[p])
        this.names.add(jury.nombre_completo)
        this.users.add(jury.usuario)
        this.categories.add(this.genre[jury.genero].nombre)
        data_jury.push({ 
          id : jury.id,
          full_name:jury.nombre_completo,
          name : jury.usuario,
          username_id: jury.usuario_id,
          category:jury.genero,
          categoryName:this.genre[jury.genero].nombre ,
          plays:jury.obras,
          plays_objects: plays_objects,
          country: getCountryName(jury.pais),
          ficha: jury.ficha== "undefined" ? "":jury.ficha, 
          phone: jury.telefono,
          address: jury.direcc_personal,
          email: jury.email,
          edit:''
        });

        for(var j=0;j<jury.obras.length;j++){
          let tuple = [jury.obras[j].toString(),jury.id.toString()]
          this.jury_plays.push(tuple)
        }
      }
    };
    
    var data = []
    this.emails = new Set();
    this.countries = new Set();
    for(var i in this.plays_dict){
      var play = this.plays_dict[i];
      this.emails.add(play.email)
      this.countries.add(play.pais)
      if((this.props.juryType == this.genre[play.genero].nombre || this.props.juryType == "all") && play.califica ){
        var date= new Moment(play.fecha_registro).format('DD-MM-YYYY')
        const year = date.split('-')[2]  
        data.push(
              { 
                key : play.id.toString(),
                code: year+'_'+play.genero+'_'+play.id,
                authorStr:play.authorStr,
                title : play.titulo,
                category: play.genero,
                categoryName: this.genre[play.genero].nombre,
                pseudo:play.pseudonimo,
                countryName:play.countryName
              });
      }
    };

    this.categories =[...this.categories].map((v)=>{
      return {value:v}
    })
    this.names = [...this.names].map((v)=>{
      return {value:v}
    })
    this.users = [...this.users].map((v)=>{
      return {value:v}
    })
    this.emails =[...this.emails].map((v)=>{
      return {value:v}
    })
    this.countries = [...this.countries].map((v)=>{
      return {value:v}
    })
    console.log("FILTERED INFO",data)
    this.setState({
      plays: data_jury,
      filteredInfo: data,
      genre:this.genre,
      isBusy:false });
    }
  isArrayInArray(arr, item){
    var item_as_string = JSON.stringify(item);
    var contains = arr.some(function(ele){
      return JSON.stringify(ele) === item_as_string;
    });
    return contains;
  }

  onChangeSelect(value){
    this.setState({countryChanged:value})
  }

  onChangeSelectJuryCategory(value){
    this.setState({newJuryCategory:value, assignedPlays:[]})
  }

  handleTableChange = (pagination, filters, sorter, extra) => {
    this.setState({filteredInfo: extra['currentDataSource']});
  }
  
  getAutocomplete = (dataIndex) =>{
    if(dataIndex == "full_name"){
      return this.names
    }
    
    else if (dataIndex == "name" ) {
      return this.users
    } 

    else if (dataIndex== "categoryName"){
      return this.categories
    }
  }
  onClickJury = record  => {
    this.setState({showArticle:true,record:record});
    var unassigned = []
    for(var i in this.plays_dict){
      if(!record.plays.includes(i)){
        unassigned.push(i)
      }
    }

    this.setState({ assignedPlays:[...record.plays]})
  };

  async onClickSaveEdit(){
    var options = {
       method: "patch",
       credentials: "same-origin",
       headers: {
         "Authorization": localStorage.getItem("Authorization") ,
         "Accept": "application/json",
         "Content-Type": "application/json"},
     }
     
    var userChanged = {
      username: document.getElementById("nameInput").value,
      email: document.getElementById("emailInput").value,
    }
    if(document.getElementById("password").value.trim() != "")
      userChanged["password"] = document.getElementById("password").value

    await axios.patch(IP + `api/casa/usuario/${this.state.record.username_id}/`, userChanged, options)
    .then(
      (response) => {
        if(response.status === 200)
           console.log(response);
         else{
           notification.error({
           message:'Error',
           description:'Hubo un error, por favor revise los datos',
         });
         return
         }
      },
      (error) => {
       notification.error({
         message:'Error',
         description:'Hubo un error, por favor revise los datos',
       })
       return
      }
    ).catch((err) => console.log(err))
    var juryChanged={
      nombre_completo: document.getElementById("fullNameInput").value,
      telefono: document.getElementById("phoneInput").value,
      direcc_personal:document.getElementById("addressInput").value,
      ficha:document.getElementById("fichaInput").value,
      pais:this.state.countryChanged?getCountryCode(this.state.countryChanged):getCountryCode(this.state.record.country),
      obras:this.state.saveAddPlays? this.state.assignedPlays.map(p=> parseInt(p)): this.state.record.plays
    }
     
     await axios.patch(IP + `api/casa/jurado/${this.state.record.id}/`, juryChanged, options)
     .then(
       (response) => {
         if(response.status === 200)
            window.location.reload()
          else{
            notification.error({
            message:'Error',
            description:'Hubo un error, por favor revise los datos',
          });
          }
       },
       (error) => {
        notification.error({
          message:'Error',
          description:'Hubo un error, por favor revise los datos',
        })
       }
     ).catch((err) => console.log(err))
   }

  onClickEditJury= record  => {
    var assigned = record.plays.map(p=>p.toString())
    const ids = this.jury_plays.map(h=>h[0])


    var unassigned = this.state.filteredInfo.filter(p=>p.category == record.category && (!ids.includes(p.key) || this.isArrayInArray(this.jury_plays,[p.key,record.id.toString()])))
    this.setState({edit:true,record:record,unassignedPlays:[...unassigned], assignedPlays:[...assigned], newJuryCategory:record.category});
  };
  onClickDeleteJury= record  => {
    fetch(IP + `api/casa/jurado/${record.id.toString()}/`,{
      method:'DELETE',
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"},
     
    }).then(async (res) => {
      if (res.status == 204){
        window.location.reload(false)
      } 
      }).catch((err) => {
        notification.error({
          message:'Error',
          description:"Hubo un error. Intente mas tarde por favor",
        });
    })
  };
  hideModal = () => {
        this.setState({
          showArticle: false,
          record: null,
          assignedPlays:[],
          unassignedPlays:[]
        });
  };

  hidePlaysModal = () => {
    this.setState({
      showPlays: false,
     
    });
  };

  hideEdit = () => {
    this.setState({
      edit: false,
      record: null,
      newJuryCategory:1
    });
  };
showAdd = ()=>{
  this.setState({showAddPlays:true})
}
getColumnPlaysSearchProps = (dataIndex,nombre) => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <AutoComplete 
      style={{ width: 188, marginBottom: 8, display: 'block' }}
      options={this.getAutocomplete(dataIndex)}
      filterOption={(inputValue,option)=>option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
      onChange={(value)=>{setSelectedKeys(value ? [value] : [])}}
      value={selectedKeys[0]}

      >
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Buscar ${nombre}`}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        />
      </AutoComplete>
      <Space>
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90 }}
        >
          Buscar
        </Button>
        <Button onClick={() =>{setSelectedKeys([]); this.handleReset(clearFilters)}} size="small" style={{ width: 90 }}>
          Resetear
        </Button>

      </Space>

    </div>
  ),
  filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
  onFilter: (value, record) =>
    dataIndex!="author"?
     (record[dataIndex]
      ? record[dataIndex].toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase())
      : ''):
      (record[dataIndex]? record[dataIndex].some(auth=>auth['name'].normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase())):'')
 ,
  onFilterDropdownVisibleChange: visible => {
    if (visible) {
      setTimeout(() => this.searchInput.select(), 100);
    }
  },
  render: (text,record,index) =>
     this.state.searchedColumn === dataIndex ? (
       dataIndex !="author"?
      (<div style={{fontSize:'large' }}>
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text ? text.toString() : ''}
      />
      </div>):
      record[dataIndex].map(auth=>
      (<div style={{fontSize:'large' }}>
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={auth['name'] ? auth['name'] : ''}
      />
      </div>))
    ) : (
      <div style={{fontSize:'large' }}>
        {(dataIndex=="author" && <ol>{record.author.map((a,idx)=>{return <li>{a.name} </li>})}</ol> )
        || (  <div>{text}</div>)  }
      </div>
    ),
});
  getColumnSearchProps = (dataIndex,name) => dataIndex!='edit' && ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => ( dataIndex!='edit' &&
          <div style={{ padding: 8 }}>
            <AutoComplete 
            style={{ width: 188, marginBottom: 8, display: 'block' }}
            options={this.getAutocomplete(dataIndex)}
            filterOption={(inputValue,option)=>option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
            onChange={(value)=>{setSelectedKeys(value ? [value] : [])}}
            value={selectedKeys[0]}
            >
             <Input
               ref={node => {
                this.searchInput = node;
              }}
              placeholder={`Buscar ${name}`}
              onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            />
            </AutoComplete>
            <Space>
              <Button
                type="primary"
                onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                icon={<SearchOutlined />}
                size="small"
                style={{ width: 90 }}
              >
                Buscar
              </Button>
              <Button onClick={() => this.handleReset(clearFilters)} size="small" type="reset" style={{ width: 90 }}>
                Resetear
              </Button>
    
            </Space>
          </div>
        ),
        filterIcon: filtered =>dataIndex!='edit' && <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
          record[dataIndex]
            ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
            : '',
        onFilterDropdownVisibleChange: visible => {
          if (visible && dataIndex!= 'edit') {
            setTimeout(() => this.searchInput.select(), 100);
          }
        },
        render: (text,record,index) =>
          this.state.searchedColumn === dataIndex ? (
            <div style={{fontSize:'large' }}>
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={text ? text.toString() : ''}
            />
            </div>
          ) : (
            <div  style={{fontSize:'large' }}>
            {(dataIndex=='edit' && <a onClick={()=>{this.onClickEditJury(record)}}> <EditOutlined /></a>)||
            <a onClick = {()=>this.onClickJury(record)} >  {text} </a>}
            </div>
          ),
      });
    
      handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        this.setState({
          searchText: selectedKeys[0],
          searchedColumn: dataIndex,
        });
      };
    
      handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
      };
      createJury =() => {
        this.setState({ create:true, assignedPlays:[] });
      };
      closeCreateJury =() => {
        this.setState({ create:false });
      };
      onClickSavePlays=()=>{
          this.setState({showAddPlays:false,saveAddPlays:true})
      }
      onClickCancelPlays=()=>{
        this.setState({showAddPlays:false,saveAddPlays:false})
      }
      showPlays=()=>{
        this.setState({showPlays:true})
      }

      handleTransferChange = (newTargetKeys, direction, moveKeys) => {
        direction=='left'? this.setState({ assignedPlays:[...newTargetKeys] }): this.setState({ assignedPlays:this.state.assignedPlays.concat(moveKeys) })
      };
      handleSubmit = (form)=>{
        const data= new FormData()
        this.setState({isBusy:true},()=>axios.post(IP + 'api/casa/register/', data).then((res) => {
        if (res.status == 200){
          this.setState({isBusy:false})
          Modal.success({
            content: 'Gracias por registrarse en el concurso',
            onOk:()=> window.open("/casa/registro","_self")
          });
         
        } ;
      }).catch((err) => {
        this.setState({isBusy:false})
        notification.error({
          message:'Error',
          description:err.response.data.non_field_errors[0],
        });
        
      }))
      }
  render() {
    const { Content } = Layout;
    const Moment = require('moment');
    const columnsPlays =  [
      {
        title: <div style={{fontWeight:'bold', fontSize:'large'}}>Número</div>,
        dataIndex: 'code',
        key: 'code',
        width:'8%',
        ...this.getColumnPlaysSearchProps('code','número'),
        responsive: ['sm'] 
      },
      {
        title: <div style={{fontWeight:'bold', fontSize:'large'}}>Título</div>,
        dataIndex: 'titulo',
        key: 'titulo',
        sorter: (a, b) => a.title.localeCompare(b.title),
        ...this.getColumnPlaysSearchProps('title','título'),
        responsive: ['sm'] 
      },
      {
        title: <div style={{fontWeight:'bold', fontSize:'large'}}>Seudónimo</div>,
        dataIndex: 'pseudonimo',
        key: 'pseudonimo',
        ...this.getColumnPlaysSearchProps('pseudo','seudónimo'),
        responsive: ['sm'] 
      },
      {
        title: <div style={{fontWeight:'bold', fontSize:'large'}}>Autor(es)</div>,
        dataIndex: 'author',
        key: 'author',
        ...this.getColumnPlaysSearchProps('author','autor'),
        responsive: ['sm'] 
      },
      {
        title: <div style={{fontWeight:'bold', fontSize:'large'}}>Género</div>,
        dataIndex: 'genero_nombre',
        key: 'genero_nombre',
        width:'8%',
        ...this.getColumnPlaysSearchProps('category','género'),
        responsive: ['sm'] 
      },
      {
        title: <div style={{fontWeight:'bold', fontSize:'large'}}>Fecha</div>,
        dataIndex: 'date',
        key: 'date',
        width:'8%',
        sortDirections:['ascend', 'descend', 'ascend'],
        ...this.getColumnPlaysSearchProps('date','fecha'),
        responsive: ['sm'] 
      }];
    const columns = [
      {
        title: <div style={{fontWeight:'bold', fontSize:'large' }}>Nombre</div>,
        dataIndex: 'full_name',
        key: 'full_name',
        sorter: (a, b) => a.full_name.localeCompare(b.full_name),
        sortDirections:['ascend', 'descend', 'ascend'],
        ...this.getColumnSearchProps('full_name','nombre'),
        responsive: ['sm'] 
      },
      {
          title: <div style={{fontWeight:'bold', fontSize:'large' }}>Usuario</div>,
          dataIndex: 'name',
          key: 'name',
          sorter: (a, b) => a.name.localeCompare(b.name),
          sortDirections:['ascend', 'descend', 'ascend'],
          ...this.getColumnSearchProps('name','usuario'),
          responsive: ['sm'] 
        },
        {
          title: <div style={{fontWeight:'bold', fontSize:'large'}}>Género</div>,
          dataIndex: 'categoryName',
          key: 'categoryName',
          width:'20%',
          sorter: (a, b) => a.email.localeCompare(b.email),
          sortDirections:['ascend', 'descend', 'ascend'],
          ...this.getColumnSearchProps('categoryName','género'),
          responsive: ['sm'] ,

        },
        {
          title: <div style={{  position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignElements:'center',fontWeight:'bold', fontSize:'large'}}>Editar</div>,
          dataIndex: 'edit',
          key: 'edit',
          
          width:'90px',
          render: (text,record) =>(
                      <div style={{ 
                            position: 'relative',
                            display: 'flex',
                            justifyContent: 'center',
                            alignElements:'center',
                            fontSize:'large' }}>
                          <a onClick={()=>{this.onClickEditJury(record)}}> <EditOutlined /></a>
                      </div>),
          sortDirections:['ascend', 'descend', 'ascend'],
          responsive: ['sm'] 
        },
        {
          title: <div style={{  position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignElements:'center',fontWeight:'bold', fontSize:'large'}}>Eliminar</div>,
          dataIndex: 'delete',
          key: 'delete',
          
          width:'90px',
          render: (text,record) =>(
                      <div  style={{     position: 'relative',
                      display: 'flex',
                      justifyContent: 'center',
                      alignElements:'center', fontSize:'large' }}>
                          <Popconfirm
                          title="Está seguro que desear eliminar este jurado?"
                          onConfirm={()=>{this.onClickDeleteJury(record)}}
                          okText="Si"
                          cancelText="No"
                        >
                          <a> <DeleteOutlined /></a>
                        </Popconfirm>,
                      </div>),
          sortDirections:['ascend', 'descend', 'ascend'],
          responsive: ['sm'] 
        }];
      const formItemLayout = {
        labelCol: {
          xs: {
            span: 24,
          },
          sm: {
            span: 8,
          },
        },
        wrapperCol: {
          xs: {
            span: 24,
          },
          sm: {
            span: 16,
          },
        },
      };
      const validateMessages =  {
        required: '${label} es requerido!',
        types: {
          email: '${label} no es un email válido!',
          number: '${label} no es un número válido!',
        },
        number: {
          range: '${label} must be between ${min} and ${max}',
        },
      }

      const customRequest = (form) => {
        const data= new FormData()
        
        form['telefono'] = form['telefono'] == undefined ? '': '+' + form['telefono']
        
        if (form['direcc_personal'] == undefined)
          form['direcc_personal'] = ''
        if (form['email'] == undefined)
          form['email'] = ''
        for ( var key in form ) {
          if(key =='autores'){
            data.append(key,JSON.stringify( form[key]));
          }
          else{
            if(key != 'genero')
            data.append(key, form[key]);
          }
        }
    
        data.append('premio',4)

        console.log("FORM GENERO",form['genero'])
        var gen = form['genero'] == undefined ? 2:form['genero']
        data.append('genero',gen)
        this.setState({isBusy:true},()=>
          axios.post(IP + 'api/casa/jurado/register',data,{
              headers: {
              "Authorization": localStorage.getItem("Authorization") ,
              "Accept": "application/json",
              "Content-Type": "application/json"
              }
          }).then((res) => {
            if (res.status == 200){
              this.setState({isBusy:false,assignedPlays:[]})
              Modal.success({
                content: 'Jurado registrado',
                onOk:()=> window.location.reload(false)
              });
            }}).catch((err) => {
              var errorsMessage = err.response.data.join(';')
              this.setState({isBusy:false})
              notification.error({
                message:'Error',
                description:errorsMessage ,
              })})
        )
      }
    return (
      <div className="page-container">
      <div className = "content-wrap">
      <ConfigProvider locale={es_ES}>
            <Layout style={{backgroundColor:'white'}}>
             <AdminMenu defaultSelectedKey = {"jury"}/>
            <Content>
                  <Row  align="middle" justify="center">
                    <Col span={12}>
                      <Table 
                      loading={this.state.isBusy}
                      columns={columns}
                      bordered 
                      dataSource= {this.state.plays}
                      pagination={{ position: ["bottomCenter"],}}
                      tableLayout='fixed'
                      style={{ whiteSpace: 'normal'}}
                      size="medium"
                      footer={()=> <Button onClick={this.createJury}style={{alignItems:'end', width:'100%'}}>Añadir jurado</Button>}
                      />
                    </Col>
                  </Row>
                {
                    this.state.showArticle && 
                    <Modal 
                    closable = {false}
                        title={ this.state.record.title}
                        visible={this.state.showArticle} 
                        onCancel={this.hideModal}
                        footer={[
                            <Button key="back" onClick={this.hideModal}>
                            Regresar
                            </Button>,
                        ]}
                        >
                        <p><UserOutlined /> Nombre completo: {this.state.record.full_name}</p>
                        <p><UserOutlined /> Usuario: {this.state.record.name}</p>
                        <p><MailOutlined /> Email: {this.state.record.email}</p>
                        <p><PhoneOutlined /> Teléfono: {this.state.record.phone}</p>
                        <p><GlobalOutlined /> País: {this.state.record.country}</p>
                        <p><EnvironmentOutlined /> Dirección: {this.state.record.address}</p>
                        <p><IdcardOutlined /> Ficha: {this.state.record.ficha}</p>
                        <p> <Button key="back" onClick={this.showPlays}>
                              Ver obras
                              </Button></p>
                    </Modal>
                    }
                  {
                    this.state.showPlays && 
                    <Modal 
                      width='90%'
                      closable = {false}
                      title={ this.state.record.name + " - Obras"}
                      visible={this.state.showPlays} 
                      footer={[
                          <Button key="back" onClick={this.hidePlaysModal}>
                            Regresar
                          </Button>]}
                    >
                      <Table
                      bordered
                      columns={columnsPlays}
                      dataSource= {this.state.record.plays_objects}
                      pagination={{ position: ["bottomCenter"],}} 
                      tableLayout='auto'
                      size='small'
                      style={{ whiteSpace: 'normal'}}/>
                    </Modal>
                  }
                  { this.state.showAddPlays && 
                    <Modal 
                      closable = {false}
                      title={ "Añadir obras al jurado"}
                      visible={this.state.showAddPlays} 
                      width={1080}
                      footer={[
                        <Button key="save" onClick={this.onClickSavePlays}>
                          Guardar
                        </Button>,
                        <Button key="back" onClick={this.onClickCancelPlays}>
                          Cancelar
                        </Button>,
                        ]}>
                      <Row align="middle" justify="center" >
                        <Col span={24}>
                          <Transfer 
                            onChange={this.handleTransferChange}
                            dataSource={ this.state.unassignedPlays}
                            targetKeys={this.state.assignedPlays}
                            listStyle={{ width: 500,height: 300}}
                            render={item => {return item.code +"--"+ item.pseudo + '--'+item.title}}
                            titles={['Sin asignar', 'Asignadas']}
                          />
                        </Col>
                      </Row>
                    </Modal>}
                    { this.state.edit && 
                      <Modal 
                        closable = {false}
                        title={ this.state.record.title}
                        visible={this.state.edit} 
                        footer={[
                          <Button key="save" onClick={()=>this.onClickSaveEdit()}>
                            Guardar
                          </Button>,
                          <Button key="back" onClick={this.hideEdit}>
                            Regresar
                          </Button>,
                        ]}>
                        <p><UserOutlined /> Nombre completo:<Input defaultValue= {this.state.record.full_name} id="fullNameInput" /> </p>
                        <p><UserOutlined /> Usuario:<Input defaultValue= {this.state.record.name} id="nameInput" /> </p>
                        <p><UserOutlined /> Cambiar contraseña:<Input.Password id="password" /> </p>
                        <p><MailOutlined /> Email:<Input defaultValue= {this.state.record.email} id="emailInput" /></p>
                        <p><PhoneOutlined /> Teléfono: <Input defaultValue= {this.state.record.phone} id="phoneInput" /> </p>
                        <p><GlobalOutlined /> País:<br/> 
                            <Select style={{width:'100%'}} showSearch defaultValue={this.state.record.country} onChange={(value)=>this.onChangeSelect(value)} >
                              {countries["countries"].sort((a,b)=>a["name_es"].localeCompare(b["name_es"])).map((obj)=>{
                                    return <Option value={obj["name_es"]}>{obj["name_es"]}</Option>
                              })}
                            </Select> 
                        </p>
                        <p><EnvironmentOutlined /> Dirección: <Input defaultValue= {this.state.record.address} id="addressInput" /></p>
                        <p><IdcardOutlined /> Ficha: <Input defaultValue= {this.state.record.ficha} id="fichaInput" /></p>
                        <p> <Button key="back" onClick={this.showAdd}> Añadir obras </Button> </p>
                      </Modal>}
                      
                      { this.state.create && 
                        <Modal 
                          closable = {false}
                          title={"Añadir jurado"}
                          visible={this.state.create} 
                          onCancel={this.closeCreateJury}
                          footer={[
                            <Button key="back" onClick={this.closeCreateJury}>
                              Regresar
                            </Button>,
                          ]}
                        >
                          <Form {...formItemLayout} id='regForm' name="nest-messages" onFinish={customRequest} validateMessages={validateMessages} layout = 'horizontal' initialValues={{autores: [""]}}>
                          
                          <Row  justify="center" align="middle" >
                            <Col xs={{span:24, offset:0 }}sm={{span:24, offset:0 }}>
                              <Row  justify="center" align="middle" >
                                <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                  <Form.Item name={['nombre_completo']} fieldKey={['first']} label="Nombre completo" rules={[{ required: true }]}>
                                    <Input style={{width:'80%'}}/>
                                  </Form.Item>
                                </Col>
                              </Row>


                              <Row  justify="center" align="middle" >
                                <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                  <Form.Item name={['username']} fieldKey={['first']} label="Nombre de usuario" rules={[{ required: true }]}>
                                    <Input style={{width:'80%'}}/>
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row  justify="center" align="middle" >
                                <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                  <Form.Item name={['password']} fieldKey={['first']} label="Contraseña" rules={[{ required: true }]}>
                                    <Input style={{width:'80%'}}/>
                                  </Form.Item>
                                </Col>
                              </Row>
                                          
                              <Row  justify="center" align="middle" >
                                <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                    <Form.Item  name={['pais']} label="País" fieldKey={[ 's']} rules={[{ required: true }]}>
                                      <Select style={{width:'80%'}} showSearch className="my-select">
                                        {countries["countries"].sort((a,b)=>a["name_es"].localeCompare(b["name_es"])).map((obj)=>{
                                          return <Option value={obj["code"]}>{obj["name_es"]}</Option>
                                      })}
                                        </Select>
                                    </Form.Item>
                                  </Col>
                              </Row>
                              <Row  justify="center" align="middle" >
                               <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                  <Form.Item  name={[ 'email']} label="Correo electrónico" rules={[{ type: 'email',  required: false }]}>
                                    <Input style={{width:'80%'}} />
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row  justify="center" align="middle" >
                                <Col xs={{span:24, offset:2}}sm={{span:24, offset:0 }}>
                                  <Form.Item  name={[ 'telefono']} label="Teléfono" rules={[{ required: false }]}>
                                    <PhoneInput
                                      localization={es}
                                      country={'cu'}
                                      enableSearch={true}
                                      searchPlaceholder="Buscar"
                                      value={this.state.phone}
                                      autoFocus= {true}
                                      onChange={phone => this.setState({ phone })}
                                      placeholder ={"Número de teléfono"}
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                              
                              <Row  justify="center" align="middle" >
                                <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                  <Form.Item name={[ 'direcc_personal']} label="Dirección postal"rules={[{ required: false }]}>
                                    <Input style={{width:'80%'}}/>
                                  </Form.Item>
                                </Col>
                              </Row>
                              
                              <Row  justify="center" align="middle" >
                                <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                  <Form.Item  name={[ 'ficha']} label="Ficha bio-bibliográfica">
                                    <Input.TextArea  placeholder='Máximo 500 caracteres' style={{width:'80%'}} />
                                  </Form.Item>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <Row  justify="center" align="middle" >
                            <Col xs={{span:22, offset:2 }}sm={{span:24, offset:0 }}>
                              <Form.Item name={[ 'genero']} label="Género">
                                <Select onChange={(value)=>this.onChangeSelectJuryCategory(value)} defaultValue={this.state.newJuryCategory} style={{width:'80%'}}>
                                  {(Object.values(this.state.genre).map((obj)=>{
                                    if(obj.nombre != "Admin")
                                      return ( <Option value={obj.id}>{obj.nombre}</Option>)  
                                  }))}
                                </Select>
                              </Form.Item>
                            </Col>
                          </Row>
                            
                        <Row  justify="center" align="middle" >
                          <Col xs={{span:22, offset:2 }}sm={{span:16, offset:8 }}>
                            <Form.Item  >
                                <Button icon={<CheckOutlined/>} type="primary" htmlType="submit" size='small' >
                                  Registrar
                                </Button>
                            </Form.Item>
                          </Col>
                        </Row>
                          </Form>
                      </Modal>}
            </Content>
          </Layout>
        </ConfigProvider>
    </div>
    <Foot admin={true}/>
    </div>
    );
  }
}
export default AdminJury;


